module.exports = __webpack_public_path__ + "static/media/sharepoint-link.389973e5.svg";